import React from 'react';

const PARTNERS = [
    { name: 'SeedLegals', logo: require('../../../../images/landing-pages/home-page/partner-logos/seedlegals_logo.png') },
    { name: 'AI Forge', logo: require('../../../../images/landing-pages/home-page/partner-logos/aI_forge_logo.png') },
    { name: 'Acentis', logo: require('../../../../images/landing-pages/home-page/partner-logos/acentis_logo.png') },
    { name: 'Dignus Muneris', logo: require('../../../../images/landing-pages/home-page/partner-logos/dignus_muneris_logo.png') },
    { name: 'EHE', logo: require('../../../../images/landing-pages/home-page/partner-logos/ehe_logo.png') },
    { name: 'Fractionality', logo: require('../../../../images/landing-pages/home-page/partner-logos/fractionality_logo.png') },
    { name: 'JPJ', logo: require('../../../../images/landing-pages/home-page/partner-logos/jpj_logo.png') },
    { name: 'SU2SU', logo: require('../../../../images/landing-pages/home-page/partner-logos/su2su_logo.png') },
    { name: 'ACF Investors', logo: require('../../../../images/landing-pages/home-page/partner-logos/acf_investors_logo.png') },
    { name: 'AngelGroups', logo: require('../../../../images/landing-pages/home-page/partner-logos/angelgroups_logo.png') },
    { name: 'British Business Bank', logo: require('../../../../images/landing-pages/home-page/partner-logos/british_business_bank_logo.png') },
    { name: 'British Design Fund', logo: require('../../../../images/landing-pages/home-page/partner-logos/british_design_fund_logo.png') },
    { name: 'Deepbridge', logo: require('../../../../images/landing-pages/home-page/partner-logos/deepbridge_logo.png') },
    { name: 'Foresight', logo: require('../../../../images/landing-pages/home-page/partner-logos/foresight_logo.png') },
    { name: 'Kero', logo: require('../../../../images/landing-pages/home-page/partner-logos/kero_logo.png') },
    { name: 'Key Capital', logo: require('../../../../images/landing-pages/home-page/partner-logos/key_capital_logo.png') },
    { name: 'Key Fund', logo: require('../../../../images/landing-pages/home-page/partner-logos/key_fund_logo.png') },
    { name: 'Lifted', logo: require('../../../../images/landing-pages/home-page/partner-logos/lifted_logo.png') },
    { name: 'Mercia Fund', logo: require('../../../../images/landing-pages/home-page/partner-logos/mercia_fund_logo.png') },
    { name: 'Northern Gritstone', logo: require('../../../../images/landing-pages/home-page/partner-logos/northern_gritstone_logo.png') },
    { name: 'Northstar Ventures', logo: require('../../../../images/landing-pages/home-page/partner-logos/northstar_ventures_logo.png') },
    { name: 'Par Equity', logo: require('../../../../images/landing-pages/home-page/partner-logos/par_equity_logo.png') },
    { name: 'Playfair', logo: require('../../../../images/landing-pages/home-page/partner-logos/playfair_logo.png') },
    { name: 'River Capital', logo: require('../../../../images/landing-pages/home-page/partner-logos/river_capital_logo.png') },
    { name: 'Science Angel', logo: require('../../../../images/landing-pages/home-page/partner-logos/science_angel_logo.png') },
    { name: 'SolidBond', logo: require('../../../../images/landing-pages/home-page/partner-logos/solidbond_logo.png') },
    { name: 'YFM Equity', logo: require('../../../../images/landing-pages/home-page/partner-logos/yfm_equity_logo.png') },
];

const HomeLogoStrip = () => (
    <section className="lp-logos-sec">
        <p className="lp-logos-eyebrow">Trusted by 50+</p>
        <h2 className="lp-logos-title">Our InvestorMatch Partners</h2>
        <div className="lp-logos-strip">
            <div className="lp-logos-track">
                {[...PARTNERS, ...PARTNERS].map((partner, i) => (
                    <span className="lp-logo-chip" key={i}>
                        <img src={partner.logo} alt={partner.name} />
                    </span>
                ))}
            </div>
        </div>
    </section>
);

export default HomeLogoStrip;
